export default __webpack_public_path__ + "static/media/cam.792a48ac.jpg";